import axiosService from '../services/axiosService';
import { DOMAIN } from 'constants';

const ttsUrl = 'api/v2/text_to_speeds';

export const readVoice = params => {
  return axiosService.post(`${DOMAIN}/${ttsUrl}`, params);
};
